import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Col from 'antd/lib/col'
import 'antd/lib/col/style/css'

const ColComponent = (props) => {
  const { className } = props

  return <Col {...props} className={classnames('col-component', className)} />
}

ColComponent.propTypes = {
  className: PropTypes.string,
}

export default ColComponent
